import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import { getRequestVerificationToken } from '../utility/ajax-helpers';
import { validateZipCode } from '../utility/validationService';

function updateShippingAndTotal(html) {
    document.getElementById('shippingAndTotal').innerHTML = html;
}

function updateCartItems(html) {
    document.getElementById('js-cart-overview-container').innerHTML = html;
}

function updateCartHeader(html) {
    document.getElementById('js-cart-overview-header-container').innerHTML = html;
}

export function updateDeliveryOptions(zipCode) {
    if (!zipCode) {
        $('.js-click-and-collect-section').addClass('u-hidden');
        $('.js-delivery-options').addClass('u-hidden');
        $('.js-delivery-options-error').removeClass('u-hidden');

        return;
    }

    const $deliveryOptionsSection = $('.js-checkout-delivery');
    $deliveryOptionsSection.addClass('loading');

    const params = {
        url: '/cart/updateDeliveryOptions',
        type: 'POST',
        data: {
            zipCode
        },
        headers: {
            ...getRequestVerificationToken
        }
    };

    $.ajax(params)
        .done((res) => {
            if (res.IsSuccess) {
                updateShippingAndTotal(res.CartOverview);
                updateCartItems(res.CartOverviewItemsHtml);
                updateCartHeader(res.CartOverviewHeaderHtml);
                $deliveryOptionsSection.html(res.DeliveryOptionsHtml);
            }
        })
        .fail((error) => {
            console.error(`${error.status} - ${error.statusText}`);
        })
        .always(() => {
            $deliveryOptionsSection.removeClass('loading');
        });
}

function onZipcodeFieldBlur(e) {
    e.preventDefault();

    const $zipCodeField = $(e.target);
    const zipCode = $zipCodeField.val();
    const countryCode = $zipCodeField.data('country-code');
    const isUpdateDeliveryOptionsEnabled = $zipCodeField.data('update-delivery-options');

    if (!isUpdateDeliveryOptionsEnabled) return;

    validateZipCode(zipCode, countryCode)
        .then(({ isValid }) => {
            if (isValid) {
                updateDeliveryOptions(zipCode);
            } else {
                updateDeliveryOptions();

                $('[name=OrderViewModel\\.SelectedShippingMethodId]').each(function () {
                    this.value = '';
                    this.checked = false;
                });
            }
        });
}

// Save checkout information
function restoreBoolValueFromLocalStorage(id) {
    const realId = 'chechoutParameter_' + id;
    const storageItem = localStorage.getItem(realId);

    if (!storageItem || storageItem === 'false') {
        return;
    }
    $('#' + id).trigger('click');
}

function restoreValueFromLocalStorage(id) {
    const realId = 'chechoutParameter_' + id;
    const storageItem = localStorage.getItem(realId);

    if (!storageItem) {
        return;
    }

    $('#' + id).val(storageItem);
}

function restoreValuesFromLocalStorage() {
    restoreValueFromLocalStorage('OrderViewModel_BillingAddress_FullName');
    restoreValueFromLocalStorage('OrderViewModel_BillingAddress_FullAddress');
    restoreValueFromLocalStorage('OrderViewModel_BillingAddress_ZipCode');
    restoreValueFromLocalStorage('OrderViewModel_BillingAddress_City');
    restoreValueFromLocalStorage('OrderViewModel_Phone');
    restoreValueFromLocalStorage('OrderViewModel_Email');

    restoreBoolValueFromLocalStorage('alternativeAdr');
    restoreValueFromLocalStorage('OrderViewModel_ShippingAddress_FullName');
    restoreValueFromLocalStorage('OrderViewModel_ShippingAddress_CompanyName');
    restoreValueFromLocalStorage('OrderViewModel_ShippingAddress_FullAddress');
    restoreValueFromLocalStorage('OrderViewModel_ShippingAddress_ZipCode');
    restoreValueFromLocalStorage('OrderViewModel_ShippingAddress_City');

    restoreBoolValueFromLocalStorage('isAcceptingFlexDelivery');
}

function setUpdateDeliveryOptions($input, value) {
    $input.data('update-delivery-options', value);
}

function onContactInfoChange(e) {
    const id = $(e.currentTarget).attr('id');
    const type = $(e.currentTarget).attr('type');
    const name = $(e.currentTarget).attr('name');
    let val = '';

    switch (type) {
        case 'checkbox':
            val = $('input[name="' + name + '"]:checked').length > 0
                ? 'true'
                : 'false';
            break;
        default:
            val = $(e.currentTarget).val();
            break;
    }

    localStorage.setItem('chechoutParameter_' + id, val);
}

function init(opts) {
    const defaults = {
        selectors: {
            alternativeAdr: '.js-alternative-adr',
            loPlusMember: '.js-loPlusMember',
            coopMember: '.js-coopMember',
            glsDroppoint: '.js-glsDroppoint',
            bringDroppoint: '.js-bringDroppoint',
            clickAndCollect: '.js-click-and-collect-container',
            radioToggle: '.js-radio-toggle',
            noDoubleClickButtons: '.js-loading',
            zipCodeField: '#OrderViewModel_BillingAddress_ZipCode',
            altZipCodeField: '#OrderViewModel_ShippingAddress_ZipCode'
        }
    };

    const options = $.extend(true, defaults, opts);

    restoreValuesFromLocalStorage();

    $('.js-fill-info input').on('change', onContactInfoChange);

    const $altArdChb = $(`#${$(options.selectors.alternativeAdr + '-trigger').attr('for')}`);

    function toggleAlternativeAdr(isUpdateDeliveryOptions) {
        const $zipCodeField = $(options.selectors.zipCodeField);
        const $altZipCodeField = $(options.selectors.altZipCodeField);
        if ($altArdChb.is(':checked')) {

            $(options.selectors.alternativeAdr).slideDown(function () {
                $(options.selectors.alternativeAdr).removeClass('u-hidden');
            });

            setUpdateDeliveryOptions($zipCodeField, false); // Disable update delivery options for Billing Address zipcode when Alternative Address is checked
            if (isUpdateDeliveryOptions) updateDeliveryOptions($altZipCodeField.val());
        } else {
            $(options.selectors.alternativeAdr).slideUp(function () {
                $(options.selectors.alternativeAdr).addClass('u-hidden');
            });
            setUpdateDeliveryOptions($zipCodeField, true); // Enable it again
            if (isUpdateDeliveryOptions) updateDeliveryOptions($zipCodeField.val());
        }
    }

    toggleAlternativeAdr();

    $altArdChb.on('change', function() {
        toggleAlternativeAdr(true);
    });

    const $loPlusMemberIndicator = $(options.selectors.loPlusMember + '-trigger');
    const $loPlusMemberCheckbox = $(`#${$loPlusMemberIndicator.attr('for')}`);

    const $coopMemberIndicator = $(options.selectors.coopMember + '-trigger');
    const $coopMemberCheckbox = $(`#${$coopMemberIndicator.attr('for')}`);

    $loPlusMemberCheckbox.on('change', function () {
        $(options.selectors.loPlusMember).slideToggle(function () {
            $(options.selectors.loPlusMember).toggleClass('u-hidden');
        });
        $coopMemberCheckbox.prop('disabled', $loPlusMemberCheckbox.is(':checked'));
    });

    $coopMemberCheckbox.on('change', function () {
        $(options.selectors.coopMember).slideToggle(function () {
            $(options.selectors.coopMember).toggleClass('u-hidden');
        });
        $loPlusMemberCheckbox.prop('disabled', $coopMemberCheckbox.is(':checked'));
    });

    $('.js-checkout .js-checkout-delivery').on('change', options.selectors.radioToggle + ' :radio', function () {
        const $radio = $(this);
        const $dropdown = $(options.selectors.clickAndCollect);
        const items = document.getElementsByClassName('isDroppoint');

        const $clickAndCollectHiddenInputForValidation = $dropdown.find('[data-validate-hidden-field]');

        if ($radio.parent('label').hasClass('js-click-and-collect-trigger')) {

            $dropdown.removeClass('u-hidden');

            $('#flexDeliveryReplace').hide();
            $('#alternativeShippingAddress').hide();

            $clickAndCollectHiddenInputForValidation.attr('data-validate-hidden-field', true);
        } else {
            $dropdown.addClass('u-hidden');

            $('#flexDeliveryReplace').show();
            $('#alternativeShippingAddress').show();
            $('#flexDeliveryReplace input').removeAttr('disabled');

            $clickAndCollectHiddenInputForValidation.attr('data-validate-hidden-field', false);

        }

        for (let i = 0; i < items.length; i++) {
            items[i].value = this.value;
        }

        const formData = {
            shippingMethodId: $radio.val()
        };

        const $deliveryOptionsSection = $('.js-checkout-delivery');
        const $cartTable = $('#cartTable');
        $deliveryOptionsSection.addClass('loading');
        $cartTable.addClass('loading');

        $.post('/cart/UpdateShippingMethod', formData).then(function (res) {
            if (res.IsSuccess) {
                updateShippingAndTotal(res.DeliveryView);
                updateCartItems(res.CartOverView);
                updateCartHeader(res.CartHeader);
            }
        }).always(() => {
            $deliveryOptionsSection.removeClass('loading');
            $cartTable.removeClass('loading');
        });
    });

    $('.js-checkout .js-checkout-payment').on('change', options.selectors.radioToggle + ' :radio', function () {
        const $radio = $(this);

        const formData = {
            paymentMethod: $radio.val()
        };

        $.get('/cart/UpdatePaymentMethod', formData);
    });

    $('.js-checkout .js-checkout-delivery').on('click', options.selectors.glsDroppoint + '-action', function (e) {
        e.preventDefault();
        const formData = {
            street: $('.js-checkout').find(options.selectors.glsDroppoint + '-adr').val(),
            zipCode: $('.js-checkout').find(options.selectors.glsDroppoint + '-postal').val(),
            countryCode: 'DK',
            numberOfShops: 10
        };

        const droppointProvider = $('#droppoint').attr('provider');
        let url = '/glsparcelshop/GetParcelShops';

        if (droppointProvider === 'bring') {
            url = '/bringparcelshop/GetParcelShops';
        }

        $.get(url, formData).then(function (res) {
            if (res.Success) {
                if (res.FoundParcelShops) {
                    let selectTpl = `<option>${$(options.selectors.glsDroppoint + '-select').find('select').data('placeholder')}</option>`;

                    res.ParcelShops.forEach((item) => {
                        selectTpl += `<option value="${item.Number}">${item.CompanyName}, ${item.StreetName}, ${item.ZipCode}</option>`;
                    });

                    $(options.selectors.glsDroppoint + '-select').removeClass('u-hidden').find('select').html(selectTpl);
                }
            } else {
                alert(res.GeneralErrorMessage); // eslint-disable-line no-alert
            }
        });
    });

    const $contactForm = $('.js-cart-purchase');
    $contactForm.validate(
        {
            rules:
            {
                'OrderViewModel.SelectedShippingMethodId': { required: true }
            },
            messages:
            {
                'OrderViewModel.SelectedShippingMethodId': { required: 'Please select a Color' }
            }
        });
    $contactForm.on('submit', function (e) {
        const isValid = $(this).valid();
        if (!isValid) e.preventDefault();
    });

    // Coupon row form submit

    $('body').on('click', '.js-cart-coupon [type="submit"]', function (e) {
        $('.js-cart-coupon form', $(e.delegateTarget)).trigger('submit');
    });
    // Coop row form submit

    $('body').on('click', '.js-cart-coop [type="submit"]', function (e) {
        $('.js-cart-coop form', $(e.delegateTarget)).trigger('submit');
    });

    // Coop row form submit

    $('body').on('click', '.js-cart-bbl [type="submit"]', function (e) {
        $('.js-cart-bbl form', $(e.delegateTarget)).trigger('submit');
    });

    $(options.selectors.zipCodeField).on('blur', onZipcodeFieldBlur);
    $(options.selectors.altZipCodeField).on('blur', onZipcodeFieldBlur);

    // Trigger deliveryOptionsUpdate on load from local storage values
    if ($('#alternativeAdr').is(':checked')) {
        if ($(options.selectors.altZipCodeField).val()) {
            $(options.selectors.altZipCodeField).focus().blur();
        }
    } else if ($(options.selectors.zipCodeField).val()) {
        $(options.selectors.zipCodeField).focus().blur();
    }
}

export default {
    init
};
